import React, { useState, useEffect } from "react";
import AdminLeft from "./AdminLeft";
import TopBanner from "./TopBanner";
import MainMenu from "./MainMenu";
import Swal from "sweetalert2";

import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

function Searchprofile() {
    const [open, setOpen] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 768) {
                setOpen(false);
            } else {
                setOpen(true);
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const initialForm1 = {
        regNo: "",
        name: "",
        phone: "",
        job: "",
        sex: "",
        caste: "",
        age: "",
        height: "",
        star: "",
        dhosham: "",
        qualification: [""],
        native: "",
        // fee: "",
        // mode: "",
        // remarks: "",
        // date: ""
    };

    const [records, setRecords] = useState([]);
    const [filteredRecords, setFilteredRecords] = useState([]);
    const [showTable, setShowTable] = useState(false); // ✅ control table visibility

    // 🔍 SEARCH STATE
    const [searchCriteria, setSearchCriteria] = useState({
        ageFrom: "",
        ageTo: "",
        caste: "Any",
        sex: "Any"
    });

    useEffect(() => {
        fetchRecords();
    }, []);

    const fetchRecords = async () => {
        const res = await fetch("https://matrimony.cubixsystems.com/api/get.php");
        const data = await res.json();
        setRecords(data);
    };

    // 🔍 HANDLE INPUT CHANGE
    const handleSearchChange = (e) => {
        const { name, value } = e.target;
        setSearchCriteria({ ...searchCriteria, [name]: value });
    };

    // 🔍 SEARCH BUTTON
    const handleSearch = () => {
        const { ageFrom, ageTo, caste, sex } = searchCriteria;

        const result = records.filter((rec) => {
            const age = parseInt(rec.age);

            const matchAge =
                (!ageFrom || age >= parseInt(ageFrom)) &&
                (!ageTo || age <= parseInt(ageTo));

            const matchCaste =
                caste === "Any" || rec.caste === caste;

            const matchSex =
                sex === "Any" || rec.sex === sex;

            return matchAge && matchCaste && matchSex;
        });

        setFilteredRecords(result);
        setShowTable(true); // ✅ show table
    };

    // 🔁 RESET BUTTON
    const handleResetSearch = () => {
        setSearchCriteria({
            ageFrom: "",
            ageTo: "",
            caste: "Any",
            sex: "Any"
        });

        setFilteredRecords([]);
        setShowTable(false); // ❌ hide table
    };


    const exportToExcel = () => {
        if (filteredRecords.length === 0) {

            Swal.fire({
                icon: "warning",
                title: "Export to Excel",
                text: "No Data to Export"
            });
            return;

        }

        const selectedFields = ["regNo", "name", "sex", "phone", "job"];

        // ✅ Add Serial Number + selected fields
        const filteredData = filteredRecords.map((rec, index) => {
            let obj = {
                "Sl No": index + 1   // 👈 Serial Number
            };

            selectedFields.forEach(field => {
                obj[field.toUpperCase()] = rec[field];
            });

            return obj;
        });

        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Profiles");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const data = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
        });

        saveAs(data, "Profiles.xlsx");
    };


    // const exportToExcel = () => {
    //     if (filteredRecords.length === 0) {
    //         alert("No data to export");
    //         return;
    //     }

    //     const worksheet = XLSX.utils.json_to_sheet(filteredRecords);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Profiles");

    //     const excelBuffer = XLSX.write(workbook, {
    //         bookType: "xlsx",
    //         type: "array",
    //     });

    //     const data = new Blob([excelBuffer], {
    //         type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    //     });

    //     saveAs(data, "Filtered_Profiles.xlsx");
    // };



    // const exportToPDF = () => {
    //     if (filteredRecords.length === 0) {
    //         alert("No data to export");
    //         return;
    //     }

    //     const doc = new jsPDF();

    //     const tableColumn = ["Sl No", ...Object.keys(initialForm1)];

    //     const tableRows = filteredRecords.map((rec, index) => [
    //         index + 1,
    //         ...Object.keys(initialForm1).map((key) => rec[key])
    //     ]);

    //     // ✅ USE autoTable like this
    //     autoTable(doc, {
    //         head: [tableColumn],
    //         body: tableRows,
    //         startY: 20,
    //     });

    //     doc.save("Filtered_Profiles.pdf");
    // };

    const exportToPDF = () => {
        if (filteredRecords.length === 0) {
            Swal.fire({
                icon: "warning",
                title: "Export to PDF",
                text: "No Data to Export"
            });
            return;
        }

        const doc = new jsPDF();

        const selectedFields = ["regNo", "name", "sex", "phone", "job"];

        // Column headers
        const tableColumn = ["Sl No", ...selectedFields.map(f => f.toUpperCase())];

        // Rows
        const tableRows = filteredRecords.map((rec, index) => [
            index + 1,
            ...selectedFields.map(field => rec[field])
        ]);

        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 20,
        });

        doc.save("Profiles.pdf");
    };

    return (
        <div className="container-fluid p-0">

            {/* SIDEBAR TOGGLE */}
            <div
                className="top-0 start-0 p-2 fs-3 rounded shadow-sm"
                style={{
                    zIndex: 999,
                    cursor: "pointer",
                    position: "fixed",
                    left: open ? "350px" : "60px",
                    top: "0",
                    transition: "left 0.3s ease"
                }}
                onClick={() => setOpen(!open)}
            >
                <span className="displaysidemenu" style={{ position: "absolute", right: "-10px" }}>
                    ☰
                </span>
            </div>

            <div className="d-flex" style={{ height: "100vh" }}>

                {/* LEFT SIDEBAR */}
                <div
                    className="border-end leftcolor"
                    style={{
                        width: open ? "350px" : "0",
                        overflow: "hidden",
                        transition: "0.3s ease",
                    }}
                >
                    {open && (
                        <div className="p-3">
                            <AdminLeft />
                        </div>
                    )}
                </div>

                {/* RIGHT CONTENT */}
                <div
                    className="p-4"
                    style={{
                        width: open ? "calc(100% - 350px)" : "100%",
                        transition: "0.3s ease",
                        paddiingLeft: '10px'
                    }}
                >
                    <div>``
                        <TopBanner />
                    </div>

                    {/* 🔍 SEARCH UI */}

                    <div style={{ marginBottom: "20px" }}>
                       
                        <input
                            type="number"
                            name="ageFrom"
                            placeholder="Age From"
                            value={searchCriteria.ageFrom}
                            onChange={handleSearchChange}
                            style={{ width: '90px' }}
                        />

                        <input
                            type="number"
                            name="ageTo"
                            placeholder="Age To"
                            value={searchCriteria.ageTo}
                            onChange={handleSearchChange}
                            style={{ marginLeft: "10px", width: '80px' }}
                        />

                        <select
                            name="caste"
                            value={searchCriteria.caste}
                            onChange={handleSearchChange}
                            style={{ marginLeft: "10px", border: 'none', borderBottom: '1px solid black', paddingBottom: '6px' }}
                        >
                            <option value="Any">Caste Any</option>
                            <option value="Nair">Nair</option>
                            <option value="Nadar">Nadar</option>
                            <option value="Ezhava">Ezhava</option>
                            <option value="Christian">Christian</option>
                            <option value="Menon">Menon</option>
                        </select>

                        <select
                            name="sex"
                            value={searchCriteria.sex}
                            onChange={handleSearchChange}
                            style={{ marginLeft: "10px", border: 'none', borderBottom: '1px solid black', paddingBottom: '6px' }}
                        >
                            <option value="Any">Gender Any</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                        </select>

                        <button
                            onClick={handleSearch}
                            className="btn btn-primary"
                            style={{ marginLeft: "10px" }}
                        >
                            Search
                        </button>

                        <button
                            onClick={handleResetSearch}
                            className="btn btn-secondary"
                            style={{ marginLeft: "10px" }}
                        >
                            Clear
                        </button>

                        <button
                            onClick={exportToExcel}
                            className="btn btn-success"
                            style={{ marginLeft: "10px", background: 'white', color: 'maroon', cursor: 'pointer', borderBottom: '6px solid green' }}
                        >
                            Export Excel
                        </button>

                        <button
                            onClick={exportToPDF}
                            className="btn btn-danger"
                            style={{ marginLeft: "10px", background: 'white', color: 'maroon', cursor: 'pointer', borderBottom: '6px solid maroon' }}
                        >
                            Export PDF
                        </button>
                    </div>

                    {/* 📊 TABLE (ONLY AFTER SEARCH) */}
                    {showTable && (
                        <div style={{ height: "80vh", overflow: "auto" }}>
                            {filteredRecords.length === 0 ? (
                                <p>No records found</p>
                            ) : (
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>NO</th>
                                            {Object.keys(initialForm1).map((k) => (
                                                <th key={k}>{k.toUpperCase()}</th>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredRecords.map((rec, index) => (
                                            <tr key={rec.id}>
                                                <td>{index + 1}</td>

                                                {Object.keys(initialForm1).map((k) => (
                                                    <td key={k}>{rec[k]}</td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}

                </div>
            </div>
        </div>
    );
}

export default Searchprofile;